import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useUserTheme } from "src/shared/hooks/useUserTheme";

interface OrderLayoutProps {
  title: string;
  onBack: () => void;
  children: React.ReactNode;
  subtitle?: string; // Add optional subtitle prop
}

const OrderLayout: React.FC<OrderLayoutProps> = ({ title, onBack, children, subtitle }) => {
  const { bgClass, fontClass} = useUserTheme();;

  return (
    <div className="w-full h-[90vh] overflow-y-auto bg-gradient-to-br from-blue-50 to-gray-100">
      <div className="flex-1 p-2">
        <div className="max-w-9xl mx-auto">
          <div className={`relative flex items-center justify-center mb-8 ${bgClass} ${fontClass} h-16 rounded-[15px] rounded-tr-[15px]`}>
            {/* Back Button - Left Side */}
            <button onClick={onBack} className="absolute left-2 flex items-center gap-2">
              <ArrowBackIcon className="w-5 h-5" />
              <span className="font-medium">Back</span>
            </button>

            {/* Center Title */}
            <div className="text-center">
              <h1 className="text-2xl font-bold">{title}</h1>
              {subtitle && <p className=" text-sm mt-1">{subtitle}</p>}
            </div>
          </div>

          {/* Main Content */}
          {children}
        </div>
      </div>
    </div>
    // </div>
  );
};

export default OrderLayout;
